/**
 * Catálogos de frases. Cada frase é um texto ou uma função (para valores no meio da frase,
 * com tipos). O inglês define as chaves; as outras línguas têm de ter as mesmas chaves, com
 * o mesmo tipo: se faltar uma frase, a verificação de tipos falha.
 *
 *   const text = catalog({ hello: (name: string) => `Hello ${name}` }, {
 *     'pt-PT': { hello: (name) => `Olá ${name}` },
 *   });
 *   text('pt-PT').hello('Ana');
 */
import type { Locale } from './locale';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Message = string | ((...args: any[]) => string);

/** As mesmas chaves e os mesmos tipos de frase (texto ↔ texto, função ↔ função igual). */
export type Translation<C extends Record<string, Message>> = {
  [K in keyof C]: C[K] extends (...args: infer A) => string ? (...args: A) => string : string;
};

export function catalog<C extends Record<string, Message>>(
  en: C,
  others: { [L in Exclude<Locale, 'en'>]: Translation<C> },
): (locale: Locale) => Translation<C> {
  const all = { en, ...others } as unknown as Record<Locale, Translation<C>>;
  return (locale) => all[locale] ?? all.en;
}
